import { NEW_ITEM_ID } from '@/constants/campaignManagement';
import { getControlOptionsValues } from '@/helpers/filters/filterMapping';
import { useAppSelector } from '@/store/hooks';
import { selectLineItemForecast } from '@/store/selectors/campaignManagement.selectors';
import { selectShowReachInForecaster } from '@/store/selectors/currentWhitelabel.selectors';
import { memo, useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import ForecasterWidgetView from './components/ForecasterWidgetView';
import { useForecaster } from './hooks/useForecaster';

interface IProps {
  lineItemIndex: number;
  isExpanded: boolean;
}

const ForecasterWidget = memo(({ lineItemIndex, isExpanded }: IProps) => {
  const [
    watchId,
    watchChannel,
    watchGeo,
    watchAudience,
    watchProduct,
    watchDealGroups,
    watchDevices,
    watchGeoFence,
    watchPackageId,
  ] = useWatch({
    name: ['id', 'channel', 'geo', 'audiences', 'product', 'dealGroups', 'devices', 'geoFence', 'packageId'],
  });
  const isNewLineItem = useMemo(() => watchId === NEW_ITEM_ID, [watchId]);
  const lineItemForecast = useAppSelector(state => !isNewLineItem && selectLineItemForecast(state, lineItemIndex));
  const showReach = useAppSelector(selectShowReachInForecaster);

  const dealGroupIds = useMemo(() => getControlOptionsValues(watchDealGroups), [watchDealGroups]);
  const geo = useMemo(() => watchGeo, [JSON.stringify(watchGeo)]);
  const audience = useMemo(() => watchAudience, [JSON.stringify(watchAudience)]);
  const devices = useMemo(() => watchDevices, [JSON.stringify(watchDevices)]);

  const geoFence = useMemo(() => watchGeoFence, [JSON.stringify(watchGeoFence)]);

  const { activeTab, setActiveTab, forecast, loading, setDaysInRange } = useForecaster({
    channel: watchChannel?.label,
    channelId: watchChannel?.value ?? null,
    geo,
    geoFence,
    audience,
    productId: watchProduct?.id,
    dealGroupIds,
    packageId: watchPackageId,
    devices,
    isNewLineItem,
    initialForecast: lineItemForecast || null,
  });

  return (
    <ForecasterWidgetView
      isExpanded={isExpanded}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      loading={loading}
      forecast={forecast}
      showReach={showReach}
      channel={watchChannel?.label}
      setDaysInRange={setDaysInRange}
    />
  );
});

export default ForecasterWidget;
